import { Controller } from "@hotwired/stimulus"

// Client-side filter for the yearbook FAQ accordion (mirrors
// seniors_faq_search_controller.js). Each <details> item carries a
// data-search-text attribute (question + answer, lowercased) generated by
// the view, so this just does a substring match. A query also expands every
// matching item so its answer is visible in the results, and a group with
// no matches hides itself (including its heading) rather than showing an
// empty section.
export default class extends Controller {
  static targets = ["input", "group", "item", "empty", "count"]

  filter() {
    const query = this.inputTarget.value.trim().toLowerCase()
    let matches = 0

    this.groupTargets.forEach(group => {
      let groupMatches = 0

      group.querySelectorAll("details").forEach(item => {
        const visible = !query || (item.dataset.searchText || "").includes(query)
        item.hidden = !visible
        if (visible) {
          groupMatches++
          if (query) item.setAttribute("open", "")
        } else {
          item.removeAttribute("open")
        }
      })

      group.hidden = groupMatches === 0
      matches += groupMatches
    })

    if (this.hasEmptyTarget) this.emptyTarget.hidden = !(query && matches === 0)
    if (this.hasCountTarget) {
      this.countTarget.textContent = query
        ? (matches === 1 ? "1 match" : `${matches} matches`)
        : `${this.itemTargets.length} questions`
    }
  }
}
